import React from 'react';
import loadable from '@loadable/component';
import { loadGraphQLData } from '../page';
import { Helpers } from '../core/src/helpers';

const PDP = loadable(() => Helpers.retryFunc(() => import('./components-v2')));

export default {
    component: PDP,
    loadData: loadGraphQLData,
};
